/**
 * The crosswalk's lookups (2.G deliverable 22) over the committed `crosswalk-dnd5e-5.x.json`:
 * `crosswalkByUuid` reads a `Compendium.dnd5e.<pack>.<Type>.<id>` uuid (the origin of an import,
 * from `_stats.compendiumSource`); `crosswalkByName` is the "inferred" fallback where that source
 * was stripped. A `*24` pack, another system, a malformed uuid or an unknown name give null.
 */
import data from './crosswalk-dnd5e-5.x.json' with { type: 'json' };
import { CROSSWALK_PACKS, normalizeName, PACK_DOCUMENT, } from './generate.js';
/** The committed crosswalk. */
export const CROSSWALK = data;
const byId = new Map();
for (const entry of CROSSWALK.entries)
    byId.set(`${entry.pack}.${entry.compendiumId}`, entry);
/**
 * A name lookup over `entries`: by kind and folded name, null for an unknown or over-long name.
 * A name two entries of a kind share is never an answer.
 */
export function nameLookup(entries) {
    const byName = new Map();
    for (const entry of entries) {
        const key = `${entry.kind}:${normalizeName(entry.name)}`;
        byName.set(key, byName.has(key) ? null : entry);
    }
    return (kind, name) => {
        if (typeof name !== 'string' || name.length > 200)
            return null;
        return byName.get(`${kind}:${normalizeName(name)}`) ?? null;
    };
}
const byName = nameLookup(CROSSWALK.entries);
const UUID = /^Compendium\.dnd5e\.([A-Za-z0-9]{1,40})\.(Actor|Item)\.([A-Za-z0-9]{16})$/;
export function crosswalkByUuid(uuid) {
    if (typeof uuid !== 'string')
        return null;
    const m = UUID.exec(uuid);
    if (m === null)
        return null;
    const pack = m[1];
    if (!CROSSWALK_PACKS.includes(pack))
        return null;
    if (PACK_DOCUMENT[pack] !== m[2])
        return null;
    return byId.get(`${pack}.${m[3]}`) ?? null;
}
export function crosswalkByName(kind, name) {
    return byName(kind, name);
}
//# sourceMappingURL=lookup.js.map